import comp from "./SubjectGroupWithSubjectViewOnly";
export default comp;
